module.exports = require("@finance/sui/lib/components/Toast/index.js");